import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

// Initialize i18n
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: localStorage.getItem("selectedLanguage"),
    fallbackLng: ["en", "hi"],
    debug: false,

    resources: {
      en: {
        translation: {
          "No notifications available.": "No notifications available.",
          "Who We Are": "Who We Are",
          "The Winners Circle": "The Winners Circle",
          "SpotsBall in the News": "SpotsBall in the News",
          "Monday Live Stream: Who Won": "Monday Live Stream: Who Won",
          "Contact us": "Contact us",
          Legal: "Legal",
          "Trust Honestly Transparency (THT).":
            "Trust Honestly Transparency (THT).",
          Logout: "Logout",
          "Are you sure you want to logout?":
            "Are you sure you want to logout?",
          Cancel: "Cancel",
          "Sign In": "Sign In",
          emailOrPhone: "emailOrPhone",
          "Email / Mobile Number": "Email / Mobile Number",
          password: "password",
          Password: "Password",
          "Forgot Password?": "Forgot Password?",
          "Don't have an account ?": "Don't have an account ?",
          "Sign Up": "Sign Up",
          "or Sign In using": "or Sign In using",
          "Play Now": "Play Now",
          Tickets: "Tickets",
          Ticket: "Ticket",
          "Buy Bulk Tickets": "Buy Bulk Tickets",
          Discount: "Discount",
          "tickets per person": "tickets per person",
          Max: "Max",
          "Use Add and subtract buttons to increase or decrease your tickets":
            "Use Add and subtract buttons to increase or decrease your tickets",
          Quantity: "Quantity",
          "Ticket Price": "Ticket Price",
          "Grand Prize": "Grand Prize",
          Weekly: "Weekly",
          Close: "Close",
          "Every Sunday": "Every Sunday",
          "Don’t forget to tune in to our live streaming every Monday at 21:00 HRS to catch all the excitement.":
            "Don’t forget to tune in to our live streaming every Monday at 21:00 HRS to catch all the excitement.",
          "Mark your calendars and get ready to join the fun!":
            "Mark your calendars and get ready to join the fun!",
          "But don't worry, a new competition launches this Monday at 12:00 HRS!":
            "But don't worry, a new competition launches this Monday at 12:00 HRS!",
          "The current gameplay has been closed.":
            "The current gameplay has been closed.",
          "Game Play Closed!": "Game Play Closed!",
          "How To Play": "How To Play",
          "Buy Now": "Buy Now",
          "Max 75 tickets per person": "Max 75 tickets per person",
          "Use Add and subtract button for increase and decrease your tickets":
            "Use Add and subtract button for increase and decrease your tickets",
          For: "For",
          Available: "Available",
          "Discounts Available": "Discounts Available",
          "Watch on YouTube": "Watch on YouTube",
          "Watch on Facebook": "Watch on Facebook",
          "Monday- 21:00hrs": "Monday- 21:00hrs",
          "SpotsBall’s “Weekly Winner Show": "SpotsBall’s “Weekly Winner Show",
          "Every Week Live Stream": "Every Week Live Stream",
          "Sunday- 23:59hrs": "Sunday- 23:59hrs",
          "Every Week’s Contest Ends": "Every Week’s Contest Ends",
          "Mark the hidden ball in the picture!":
            "Mark the hidden ball in the picture!",
          contest: "contest",
          Current: "Current",
          "Sunday: 23:59 hrs": "Sunday: 23:59 hrs",
          "Entries Close": "Entries Close",
          D: "D",
          H: "H",
          M: "M",
          s: "S",
          "upcoming Contest": "upcoming Contest",
          "Monday: 12:00 hrs": "Monday: 12:00 hrs",
          "Entries Open": "Entries Open",
          "Today, Play and Win the game": "Today, Play and Win the game",
          "Follow Us": "Follow Us",
          "link not available": "link not available",
          "Download App": "Download App",
          Terms: "Terms",
          Conditions: "Conditions",
          "Privacy Policy": "Privacy Policy",
          "Cookie Policy": "Cookie Policy",
          FAQs: "FAQs",
          "Rules of Play": "Rules of Play",
          "No data available on selected filter":
            "No data available on selected filter",
          "Select Month": "Select Month",
          January: "January",
          February: "February",
          March: "March",
          April: "April",
          May: "May",
          June: "June",
          July: "July",
          August: "August",
          September: "September",
          October: "October",
          November: "November",
          December: "December",
          "Live Weekly Winner": "Live Weekly Winner",
          "entry deadline for last week’s contest":
            "entry deadline for last week’s contest",
          "new weekly games begins": "new weekly games begins",
          "Every Monday": "Every Monday",
          "Watch Live": "Watch Live",
          "live Facebook and YouTube stream of “The SpotsBall Weekly Winner Show”":
            "live Facebook and YouTube stream of “The SpotsBall Weekly Winner Show”",
          "Terms & Conditions": "Terms & Conditions",
          "Privacy Policies": "Privacy Policies",
          "Rules of Play & FAQs": "Rules of Play & FAQs",
          Checkout: "Checkout",
          Win: "Win",
          Spot: "Spot",
          "Bill Details": "Bill Details",
          "Items Total": "Items Total",
          "Promo Applied": "Promo Applied",
          After: "After",
          Subtotal: "Subtotal",
          "Base Amount + GST": "Base Amount + GST",
          "Platform Fee": "Platform Fee",
          "GST on Platform Fee": "GST on Platform Fee",
          "Total Platform Fee": "Total Platform Fee",
          "Grand Total": "Grand Total",
          "Subtotal + Platform": "Subtotal + Platform",
          "X- Coordinates": "X- Coordinates",
          "Y- Coordinates": "Y- Coordinates",
          Apply: "Apply",
          "Pay Now": "Pay Now",
          "Refresh All": "Refresh All",
          "Payment Status": "Payment Status",
          Payment: "Payment",
          "Thank you for your participation!":
            "Thank you for your participation!",
          "Time / Date": "Time / Date",
          "Ref. No": "Ref. No",
          "Total Amount": "Total Amount",
          "View all payments": "View all payments",
          "Winning Coordinates": "Winning Coordinates",
          "Closest Coordinate": "Closest Coordinate",
          "Contact Information": "Contact Information",
          Technical: "Technical",
          "Select Subject": "Select Subject",
          "Phone Number": "Phone Number",
          Support: "Support",
          Business: "Business",
          Message: "Message",
          "Send Message": "Send Message",
          "Change Image": "Change Image",
          "Enter First Name": "Enter First Name",
          "Enter Last Name": "Enter Last Name",
          "Enter Email id": "Enter Email id",
          "Enter Phone Number": "Enter Phone Number",
          "Update Profile": "Update Profile",
          "Enter Old Password": "Enter Old Password",
          "Enter New Password": "Enter New Password",
          "Enter Confirm Password": "Enter Confirm Password",
          "Save Password": "Save Password",
          "Download Invoice": "Download Invoice",
          "Txn. Id.": "Txn. Id.",
          "Transaction Status": "Transaction Status",
          "No Payment History Found!": "No Payment History Found!",
          "My Account": "My Account",
          "Deactivate Account": "Deactivate Account",
          "Delete Account": "Delete Account",
          "You chose to temporarily opt out of playing SpotsBall, so we":
            "You chose to temporarily opt out of playing SpotsBall, so we",
          "have put your account in deleted state. If you wish to":
            "have put your account in deleted state. If you wish to",
          "reactivate your deleted account, you can send an email to":
            "reactivate your deleted account, you can send an email to",
          "support.in@spotsball.com.": "support.in@spotsball.com.",
          "You choose to temporarily OptOut from Playing SpotsBall, we":
            "You choose to temporarily OptOut from Playing SpotsBall, we",
          "put your account in a suspended state. When/if you want to":
            "put your account in a suspended state. When/if you want to",
          "reactivate, you can send an email to":
            "reactivate, you can send an email to",
          "support.in@spotsball.com": "support.in@spotsball.com",
          ", and will receive reset instructions for your password.":
            ", and will receive reset instructions for your password.",
          "Location Setting": "Location Setting",
          "Follow the instructions based on your operating system:":
            "Follow the instructions based on your operating system:",
          "For Mac Users:": "For Mac Users:",
          "Click on the Apple menu and select":
            "Click on the Apple menu and select",
          "System Preferences": "System Preferences",
          "Click the lock icon at the bottom left and enter your password to make changes.":
            "Click the lock icon at the bottom left and enter your password to make changes.",
          "Find the app (e.g., Chrome) in the list and ensure the checkbox is checked.":
            "Find the app (e.g., Chrome) in the list and ensure the checkbox is checked.",
          "Go to": "Go to",
          "Security & Privacy": "Security & Privacy",
          "and then select the": "and then select the",
          "tab.": "tab.",
          "In the sidebar, select": "In the sidebar, select",
          "Location Services": "Location Services",
          "For Chrome:": "For Chrome:",
          "Open Chrome.": "Open Chrome.",
          "SpotsBall’s “Weekly Winner Show”":
            "SpotsBall’s “Weekly Winner Show”",
          "At the top right, click More": "At the top right, click More",
          Settings: "Settings",
          "Under “Permissions,” select": "Under “Permissions,” select",
          "Site settings": "Site settings",
          Select: "Select",
          OK: "OK",
          Allow: "Allow",
          Deny: "Deny",
          "We need to access your location to ensure you're in a region where SpotsBall is available.":
            "We need to access your location to ensure you're in a region where SpotsBall is available.",
          "Enable Location Services": "Enable Location Services ",
          "Game Unavailable in Your Region": "Game Unavailable in Your Region",
          "Sorry, SpotsBall is not available in your current location due to local regulations.":
            "Sorry, SpotsBall is not available in your current location due to local regulations.",
          "Location Access Required": "Location Access Required",
          "To play SpotsBall, you need to enable location services.":
            "To play SpotsBall, you need to enable location services.",
          "Please allow access to your location.":
            "Please allow access to your location.",
          "Know More": "Know More",
          "Frequently asked": "Frequently asked",
          questions: "questions",
          "View All": "View All",
          "Android App": "Android App",
          "App Store": "App Store",
          "Test Your Cricket Skills, Spot the Ball and":
            "Test Your Cricket Skills, Spot the Ball and",
          "Stand a Chance to Win": "Stand a Chance to Win",
          "SpotsBall is the ultimate cricket challenge app where you":
            "SpotsBall is the ultimate cricket challenge app where you",
          " can put your cricket skills to the test. At SpotsBall, we":
            " can put your cricket skills to the test. At SpotsBall, we",
          "bring the thrill of cricket right to your fingertips. We":
            "bring the thrill of cricket right to your fingertips. We",
          "host a weekly exciting contest where you simply have to":
            "host a weekly exciting contest where you simply have to",
          "spot the hidden ball in the game. Think you have got sharp":
            "spot the hidden ball in the game. Think you have got sharp",
          "eyes and cricket instincts? Find the ball, mark the exact":
            "eyes and cricket instincts? Find the ball, mark the exact",
          "coordinates, and stand a chance to win the grand prize,":
            "coordinates, and stand a chance to win the grand prize,",
          "every week.": "every week.",
          "Trending Articles": "Trending Articles",
          "": "",
          "": "",
          "": "",
        },
      },
      hi: {
        translation: {
          "No notifications available.": "कोई सूचना उपलब्ध नहीं है।",
          "Who We Are": "हम कौन हैं",
          "The Winners Circle": "विजेताओं का चक्र",
          "SpotsBall in the News": "समाचारों में SpotsBall",
          "Monday Live Stream: Who Won": "सोमवार लाइव स्ट्रीम: किसने जीता",
          "Contact us": "संपर्क करें",
          Legal: "कानूनी",
          "Trust Honestly Transparency (THT).":
            "भरोसा, ईमानदारी और पारदर्शिता (THT)।",
          Logout: "लॉग आउट",
          "Are you sure you want to logout?":
            "क्या आप वाकई लॉग आउट करना चाहते हैं?",
          Cancel: "रद्द करें",
          "Sign In": "साइन इन करें",
          emailOrPhone: "ईमेल या फोन नंबर",
          "Email / Mobile Number": "ईमेल / मोबाइल नंबर",
          password: "पासवर्ड",
          Password: "पासवर्ड",
          "Forgot Password?": "पासवर्ड भूल गए?",
          "Don't have an account ?": "क्या आपके पास खाता नहीं है?",
          "Sign Up": "साइन अप करें",
          "or Sign In using": "या साइन इन करें द्वारा",
          "Play Now": "अब खेलें",
          Tickets: "टिकट",
          Ticket: "टिकट",
          "Buy Bulk Tickets": "थोक में टिकट खरीदें",
          Discount: "छूट",
          "tickets per person": "व्यक्ति प्रति टिकट",
          Max: "अधिकतम",
          "Use Add and subtract buttons to increase or decrease your tickets":
            "अपने टिकट बढ़ाने या घटाने के लिए जोड़ें और घटाएं बटन का उपयोग करें",
          Quantity: "मात्रा",
          "Ticket Price": "टिकट मूल्य",
          "Grand Prize": "भव्य पुरस्कार",
          Weekly: "साप्ताहिक",
          Close: "बंद करें",
          "Don’t forget to tune in to our live streaming every Monday at 21:00 HRS to catch all the excitement.":
            "हर सोमवार रात 21:00 बजे हमारी लाइव स्ट्रीमिंग देखना न भूलें और रोमांच का आनंद लें।",
          "Mark your calendars and get ready to join the fun!":
            "अपनी कैलेंडर में तारीख अंकित करें और मज़े में शामिल होने के लिए तैयार हो जाएं!",
          "But don't worry, a new competition launches this Monday at 12:00 HRS!":
            "चिंता न करें, इस सोमवार दोपहर 12:00 बजे एक नई प्रतियोगिता शुरू हो रही है!",
          "The current gameplay has been closed.":
            "वर्तमान गेमप्ले बंद कर दिया गया है।",
          "Game Play Closed!": "गेमप्ले बंद!",
          "How To Play": "कैसे खेलें",
          "Buy Now": "अभी खरीदें",
          "Max 75 tickets per person": "प्रति व्यक्ति अधिकतम 75 टिकट",
          "Use Add and subtract button for increase and decrease your tickets":
            "अपने टिकट बढ़ाने और घटाने के लिए जोड़ें और घटाएं बटन का उपयोग करें",
          For: "के लिए",
          Available: "उपलब्ध",
          "Discounts Available": "छूट उपलब्ध है",
          "Watch on YouTube": "यूट्यूब पर देखें",
          "Watch on Facebook": "फेसबुक पर देखें",
          "Monday- 21:00hrs": "सोमवार - 21:00 बजे",
          "SpotsBall’s “Weekly Winner Show":
            "SpotsBall का “साप्ताहिक विजेता शो”",
          "Every Week Live Stream": "हर सप्ताह लाइव स्ट्रीम",
          "Sunday- 23:59hrs": "रविवार - 23:59 बजे",
          "Every Week’s Contest Ends":
            "हर सप्ताह की प्रतियोगिता समाप्त होती है",
          "Mark the hidden ball in the picture!":
            "चित्र में छिपे गेंद को चिह्नित करें!",
          contest: "प्रतियोगिता",
          Current: "वर्तमान",
          "Sunday: 23:59 hrs": "रविवार: 23:59 बजे",
          "Entries Close": "प्रवेश  बंद",
          D: "दिन",
          H: "घंटे",
          M: "मिनट",
          s: "सेकंड",
          "SpotsBall’s “Weekly Winner Show”":
            "स्पॉट्सबॉल का साप्ताहिक विजेता शो",
          "upcoming Contest": "आगामी प्रतियोगिता",
          "Monday: 12:00 hrs": "सोमवार: 12:00 बजे",
          "Entries Open": "प्रवेश शुरू",
          "Today, Play and Win the game": "आज ही खेलें और खेल जीतें",
          "Follow Us": "हमें फॉलो करें",
          "link not available": "लिंक उपलब्ध नहीं है",
          "Download App": "ऐप डाउनलोड करें",
          Terms: "नियम",
          Conditions: "शर्तें",
          "Privacy Policy": "गोपनीयता नीति",
          "Cookie Policy": "कुकी नीति",
          FAQs: "अक्सर पूछे जाने वाले प्रश्न",
          "Rules of Play": "खेल के नियम",
          "No data available on selected filter":
            "चयनित फ़िल्टर पर कोई डेटा उपलब्ध नहीं है",
          "Select Month": "महीना चुनें",
          January: "जनवरी",
          February: "फ़रवरी",
          March: "मार्च",
          April: "अप्रैल",
          May: "मई",
          June: "जून",
          July: "जुलाई",
          August: "अगस्त",
          September: "सितंबर",
          October: "अक्टूबर",
          November: "नवंबर",
          December: "दिसंबर",
          "Live Weekly Winner": "लाइव साप्ताहिक विजेता",
          "entry deadline for last week’s contest":
            "पिछले सप्ताह की प्रतियोगिता की अंतिम तिथि",
          "new weekly games begins": "नई साप्ताहिक प्रतियोगिता शुरू होती है",
          "Every Monday": "हर सोमवार",
          "Watch Live": "लाइव देखें",
          "live Facebook and YouTube stream of “The SpotsBall Weekly Winner Show”":
            "“SpotsBall साप्ताहिक विजेता शो” का फेसबुक और यूट्यूब पर लाइव स्ट्रीम",
          "Terms & Conditions": "नियम और शर्तें",
          "Privacy Policies": "गोपनीयता नीतियां",
          "Rules of Play & FAQs": "खेल के नियम और सामान्य प्रश्न",
          Checkout: "चेकआउट",
          Win: "जीतें",
          Spot: "स्पॉट",
          "Bill Details": "बिल विवरण",
          "Items Total": "कुल आइटम",
          "Promo Applied": "प्रोमो लागू किया गया",
          After: "के बाद",
          Subtotal: "उप-योग",
          "Base Amount + GST": "आधार राशि + जीएसटी",
          "Platform Fee": "प्लेटफ़ॉर्म शुल्क",
          "GST on Platform Fee": "प्लेटफ़ॉर्म शुल्क पर जीएसटी",
          "Total Platform Fee": "कुल प्लेटफ़ॉर्म शुल्क",
          "Grand Total": "कुल योग",
          "Subtotal + Platform": "उप-योग + प्लेटफ़ॉर्म",
          "X- Coordinates": "X- निर्देशांक",
          "Y- Coordinates": "Y- निर्देशांक",
          Apply: "लागू करें",
          "Pay Now": "अब भुगतान करें",
          "Refresh All": "सभी को रीफ्रेश करें",
          "Payment Status": "भुगतान की स्थिति",
          Payment: "भुगतान",
          "Thank you for your participation!": "आपकी भागीदारी के लिए धन्यवाद!",
          "Time / Date": "समय / तिथि",
          "Ref. No": "संदर्भ संख्या",
          "Total Amount": "कुल राशि",
          "View all payments": "सभी भुगतान देखें",
          "Winning Coordinates": "विजेता निर्देशांक",
          "Closest Coordinate": "सबसे निकट निर्देशांक",
          "Contact Information": "संपर्क जानकारी",
          Technical: "तकनीकी",
          "Select Subject": "विषय चुनें",
          "Phone Number": "फोन नंबर",
          Support: "सहायता",
          Business: "व्यवसाय",
          Message: "संदेश",
          "Send Message": "संदेश भेजें",
          "Change Image": "छवि बदलें",
          "Enter First Name": "पहला नाम दर्ज करें",
          "Enter Last Name": "अंतिम नाम दर्ज करें",
          "Enter Email id": "ईमेल आईडी दर्ज करें",
          "Enter Phone Number": "फोन नंबर दर्ज करें",
          "Update Profile": "प्रोफ़ाइल अपडेट करें",
          "Enter Old Password": "पुराना पासवर्ड दर्ज करें",
          "Enter New Password": "नया पासवर्ड दर्ज करें",
          "Enter Confirm Password": "पुष्टि पासवर्ड दर्ज करें",
          "Save Password": "पासवर्ड सहेजें",
          "Download Invoice": "चालान डाउनलोड करें",
          "Txn. Id.": "लेन-देन आईडी",
          "Transaction Status": "लेन-देन की स्थिति",
          "No Payment History Found!": "कोई भुगतान इतिहास नहीं मिला!",
          "My Account": "मेरा खाता",
          "Deactivate Account": "खाता निष्क्रिय करें",
          "Delete Account": "खाता हटाएं",
          "You chose to temporarily opt out of playing SpotsBall, so we":
            "आपने अस्थायी रूप से SpotsBall खेलने से बाहर निकलने का विकल्प चुना है, इसलिए हमने",
          "have put your account in deleted state. If you wish to":
            "आपका खाता हटाए गए स्थिति में डाल दिया है। यदि आप चाहते हैं कि",
          "reactivate your deleted account, you can send an email to":
            "अपना खाता पुनः सक्रिय करना चाहते हैं, तो आप निम्न ईमेल पर संपर्क कर सकते हैं:",
          "support.in@spotsball.com.": "support.in@spotsball.com.",
          "You choose to temporarily OptOut from Playing SpotsBall, we":
            "आपने अस्थायी रूप से SpotsBall न खेलने का निर्णय लिया है, इसलिए हमने",
          "put your account in a suspended state. When/if you want to":
            "आपका खाता निलंबित स्थिति में डाल दिया है। जब/यदि आप चाहते हैं कि",
          "reactivate, you can send an email to":
            "आप इसे पुनः सक्रिय कर सकते हैं, इसके लिए ईमेल करें:",
          "support.in@spotsball.com": "support.in@spotsball.com",
          ", and will receive reset instructions for your password.":
            "और आपको अपने पासवर्ड के लिए रीसेट निर्देश प्राप्त होंगे।",
          "Location Setting": "स्थान सेटिंग",
          "Follow the instructions based on your operating system:":
            "अपने ऑपरेटिंग सिस्टम के अनुसार निर्देशों का पालन करें:",
          "For Mac Users:": "Mac उपयोगकर्ताओं के लिए:",
          "Click on the Apple menu and select":
            "Apple मेनू पर क्लिक करें और चुनें",
          "System Preferences": "सिस्टम प्राथमिकताएं",
          "Click the lock icon at the bottom left and enter your password to make changes.":
            "नीचे बाईं ओर लॉक आइकन पर क्लिक करें और परिवर्तन करने के लिए अपना पासवर्ड दर्ज करें।",
          "Find the app (e.g., Chrome) in the list and ensure the checkbox is checked.":
            "सूची में ऐप (जैसे Chrome) खोजें और सुनिश्चित करें कि चेकबॉक्स चेक किया गया है।",
          "Go to": "जाएं",
          "Security & Privacy": "सुरक्षा और गोपनीयता",
          "and then select the": "और फिर चुनें",
          "tab.": "टैब।",
          "In the sidebar, select": "साइडबार में चुनें",
          "Location Services": "स्थान सेवाएं",
          "For Chrome:": "Chrome के लिए:",
          "Open Chrome.": "Chrome खोलें।",
          "At the top right, click More": "ऊपर दाईं ओर 'अधिक' पर क्लिक करें",
          Settings: "सेटिंग्स",
          "Under “Permissions,” select": "“अनुमतियाँ” के तहत चुनें",
          "Site settings": "साइट सेटिंग्स",
          Select: "चुनें",
          OK: "ठीक है",
          Allow: "अनुमति दें",
          Deny: "अस्वीकृत करें",
          "We need to access your location to ensure you're in a region where SpotsBall is available.":
            "हमें आपके स्थान तक पहुंचने की आवश्यकता है यह सुनिश्चित करने के लिए कि आप उस क्षेत्र में हैं जहाँ SpotsBall उपलब्ध है।",
          "Enable Location Services": "स्थान सेवाएं सक्षम करें",
          "Game Unavailable in Your Region":
            "आपके क्षेत्र में गेम उपलब्ध नहीं है",
          "Sorry, SpotsBall is not available in your current location due to local regulations.":
            "क्षमा करें, स्थानीय नियमों के कारण SpotsBall आपके वर्तमान स्थान पर उपलब्ध नहीं है।",
          "Location Access Required": "स्थान एक्सेस आवश्यक है",
          "To play SpotsBall, you need to enable location services.":
            "SpotsBall खेलने के लिए आपको स्थान सेवाएं सक्षम करनी होंगी।",
          "Please allow access to your location.":
            "कृपया अपने स्थान तक पहुंच की अनुमति दें।",
          "Know More": "और जानें",
          "Frequently asked": "अक्सर पूछे जाने वाले",
          questions: "सवाल",
          "View All": "सभी देखें",
          "Android App": "एंड्रॉइड ऐप",
          "App Store": "ऐप स्टोर",
          "Test Your Cricket Skills, Spot the Ball and":
            "अपनी क्रिकेट कौशल का परीक्षण करें, गेंद को पहचानें और",
          "Stand a Chance to Win": "जीतने का मौका पाएं",
          "SpotsBall is the ultimate cricket challenge app where you":
            "SpotsBall एक बेहतरीन क्रिकेट चैलेंज ऐप है जहां आप",
          " can put your cricket skills to the test. At SpotsBall, we":
            " अपनी क्रिकेट कौशल का परीक्षण कर सकते हैं। SpotsBall पर हम",
          "bring the thrill of cricket right to your fingertips. We":
            "क्रिकेट का रोमांच आपके हाथों तक लाते हैं। हम",
          "host a weekly exciting contest where you simply have to":
            "हर हफ्ते एक रोमांचक प्रतियोगिता आयोजित करते हैं जिसमें आपको बस",
          "spot the hidden ball in the game. Think you have got sharp":
            "खेल में छिपी गेंद को पहचानना होता है। क्या आपको लगता है कि आपकी नजर तेज़ है",
          "eyes and cricket instincts? Find the ball, mark the exact":
            "और क्रिकेट की समझ भी? गेंद को खोजें, सटीक स्थान अंकित करें,",
          "coordinates, and stand a chance to win the grand prize,":
            "और भव्य पुरस्कार जीतने का मौका पाएं,",
          "every week.": "हर हफ्ते।",
          "Every Sunday": "हर रविवार",
          "Trending Articles": "प्रचलित लेख",
          "": "",
        },
      },
    },
  });

//  .init({
//   lng: localStorage.getItem("language") || "en",
//   fallbackLng: ["en", "hi", "fr", "de"],
//   debug: false,
//   backend: {
//     loadPath: "/locales/{{lng}}/translation.json",
//   },
//   interpolation: {
//     escapeValue: false,
//   },
// });

export default i18n;
